import React, { useState, useEffect } from 'react';
import { Tile, Button, TextArea, InlineLoading } from 'carbon-components-react';
import { Close16, ThumbsUp32, ThumbsDown32, ArrowRight32, ArrowUpRight16 } from '@carbon/icons-react';
import ReactCardFlip from 'react-card-flip';
import moment from 'moment';
import callPostApi from "../../../requests/PostRequests"
import * as Constants from '../../..//requests/URLConstants';
import * as DashboardConstants from '../../Dashboards/DashboardConstants'
import * as IncidentDetailsConstants from '../IncidentDetailsPage/IncidentDetailsConstants';
import i18n from "../../../i18n";
import ReadMoreAndLess from 'react-read-more-less';
import * as workspaces from '../../../config/WorkspaceConstants';
import DashboardTable from '../../Dashboards/DashboardTable';


export default function RemediationTabUser(props) {

    const [isRemediationRootCauseFlipped, setIsRemediationRootCauseFlipped] = useState(false);
    const [isRemediationRootCauseApproveFlipped, setIsRemediationRootCauseApproveFlipped] = useState(false);
    const [isRemediationRootCauseRejectFlipped, setIsRemediationRootCauseRejectFlipped] = useState(false);
    const [RemediationRootCauseFeedbackCount, setRemediationRootCauseFeedbackCount] = useState(0);
    const [RemediationStepsFeedbackCount, setRemediationStepsFeedbackCount] = useState(0);
    const [ActionFeedbackCount, setActionFeedbackCount] = useState(0);
    const [isActionFlipped, setIsActionFlipped] = useState(false);
    const [isActionRejectFlipped, setIsActionRejectFlipped] = useState(false);
    const [isActionApproveFlipped, setIsActionApproveFlipped] = useState(false);
    const [isRemediationStepsFlipped, setIsRemediationStepsFlipped] = useState(false);
    const [isRemediationStepsRejectFlipped, setIsRemediationStepsRejectFlipped] = useState(false);
    const [isRemediationStepsApproveFlipped, setIsRemediationStepsApproveFlipped] = useState(false);
    const [remediationStepsFeedback, setRemediationStepsFeedback] = useState('');
    const [remediationRootCauseFeedback, setRemediationRootCauseFeedback] = useState('');
    const [actionFeedback, setActionFeedback] = useState('');
    const [UserSuggestedActionsDescFeedback, setUserSuggestedActionsDescFeedback] = useState(props.incidentArray.action_desc_feedback);
    const [RemediationRootCauseFeedbackClicked, setRemediationRootCauseFeedbackClicked] = useState(false);
    const [isRemediationRootCauseApproveCancelClicked, setIsRemediationRootCauseApproveCancelClicked] = useState(false);
    const [ActionFeedbackClicked, setActionFeedbackClicked] = useState(false);
    const [isActionApproveCancelClicked, setIsActionApproveCancelClicked] = useState(false);
    const [RemediationStepsFeedbackClicked, setRemediationStepsFeedbackClicked] = useState(false);
    const [isRemediationStepsApproveCancelClicked, setIsRemediationStepsApproveCancelClicked] = useState(false);
    const [QuestionAnswers, setQuestionAnswers] = useState([]);
    const [QnALoader, setQnALoader] = useState(false);
    const [salesForceRows, setSalesForceRows] = useState([]);

    let date = new Date();
    let dt = moment(date).format("Do MMM., YY");
    let suggestionMsg = `Suggestion accepted on ${dt}`;
    let feedbackMessage = `Feedback on ${dt}`;
    let feedbackToastMessage = `Your feedback has submitted on ${dt}`;

    useEffect(() => {
        setUserSuggestedActionsDescFeedback(props.incidentArray.action_desc_feedback)

    }, [props.incidentArray, props.incidentArray.action_desc_feedback]);

    useEffect(() => {
        if (props.process) {
            questionAnswers(props.process);
        }
    }, [props.process])

    const questionAnswers = (process) => {
        setQnALoader(true);
        let language = moment.locale();
        callPostApi(Constants.QUESTIONANSWERSURL, {
            'Content-Type': 'application/json',
        }, {
            "process": process,
            "client": props.client,
            "language": language
        })
            .then(data => {
                if (data) {
                    setQnALoader(false);
                    setQuestionAnswers(data.result);
                }
            }).catch((error) => {
                setQnALoader(false);
            });
    }

    //Remediation type
    const handleRemediationRootCauseApprove = (e) => {
        setIsRemediationRootCauseApproveFlipped(true);
        setIsRemediationRootCauseRejectFlipped(false);
        setIsRemediationRootCauseFlipped(!isRemediationRootCauseFlipped);
        setRemediationRootCauseFeedbackClicked(false);
        setIsRemediationRootCauseApproveCancelClicked(false);
        props.updateSomData({ 'actionable': 'A' });
    }

    const handleRemediationRootCauseReject = (e) => {
        setIsRemediationRootCauseApproveFlipped(false);
        setIsRemediationRootCauseRejectFlipped(true);
        setIsRemediationRootCauseFlipped(!isRemediationRootCauseFlipped);
        setRemediationRootCauseFeedbackClicked(false);
        setIsRemediationRootCauseApproveCancelClicked(false);
    }

    const handleRemediationRootCauseFlip = () => {
        setIsRemediationRootCauseFlipped(!isRemediationRootCauseFlipped);
    };

    const handleRemediationRootCauseFeedback = () => {
        props.updateSomData({ 'actionable': 'R', 'actionable_feedback': remediationRootCauseFeedback });
        setRemediationRootCauseFeedbackClicked(!RemediationRootCauseFeedbackClicked);
        setIsRemediationRootCauseApproveCancelClicked(false);
    };

    //Action type
    const handleActionApprove = (e) => {
        setIsActionApproveFlipped(true);
        setIsActionRejectFlipped(false);
        setIsActionFlipped(!isActionFlipped);
        setActionFeedbackClicked(false);
        setIsActionApproveCancelClicked(false);
        props.updateSomData({ 'action': 'A' });
    }
    const handleActionReject = (e) => {
        setIsActionApproveFlipped(false);
        setIsActionRejectFlipped(true);
        setIsActionFlipped(!isActionFlipped);
        setActionFeedbackClicked(false);
        setIsActionApproveCancelClicked(false);
    }
    const handleActionFlip = () => {
        setIsActionFlipped(!isActionFlipped);
    };

    const handleActionFeedback = () => {
        props.updateSomData({ 'action': 'R', 'action_feedback': actionFeedback });
        setIsActionApproveCancelClicked(false);
        setActionFeedbackClicked(!ActionFeedbackClicked);
    };

    //Remediation Steps
    const handleRemediationStepsApprove = () => {
        props.updateSomData({ 'action_desc': 'A' });
        setIsRemediationStepsApproveFlipped(true);
        setIsRemediationStepsRejectFlipped(false);
        setIsRemediationStepsFlipped(!isRemediationStepsFlipped);
        setRemediationStepsFeedbackClicked(false);
        setIsRemediationStepsApproveCancelClicked(false);
    }

    const handleRemediationStepsReject = (e) => {
        setIsRemediationStepsApproveFlipped(false);
        setIsRemediationStepsRejectFlipped(true);
        setIsRemediationStepsFlipped(!isRemediationStepsFlipped);
        setRemediationStepsFeedbackClicked(false);
        setIsRemediationStepsApproveCancelClicked(false);

    }

    const handleRemediationStepsFlip = () => {
        setIsRemediationStepsFlipped(!isRemediationStepsFlipped);
    };

    //submit feedback
    const handleRemediationStepsSubmitFeedback = () => {
        props.updateSomData({ 'action_desc': 'R', 'action_desc_feedback': remediationStepsFeedback });
        setRemediationStepsFeedbackClicked(!RemediationStepsFeedbackClicked);
        setIsRemediationStepsApproveCancelClicked(false);
    };

    const action = i18n.t('taskDetails.Action');
    const Completed = i18n.t('manageAutomation.Completed');
    const Attempts = i18n.t('manageAutomation.Attempts');
    const Info = i18n.t('manageAutomation.Info');
    const ReadMore = i18n.t('assistance.ReadMore');
    const ReadLess = i18n.t('assistance.ReadLess');
    const remediation = i18n.t('taskDetails.Remediation');

    const SalesForceTableHeaders = [
        {
            key: 'action',
            header: action
        }, {
            key: 'attempts',
            header: Attempts
        },
        {
            key: 'completed',
            header: Completed
        }, {
            key: 'info',
            header: Info
        }
    ];

    useEffect(() => {
        //useeffect for settinng salesforce data
        prepareSalesForceRemediation(props.incidentArray)
    }, [props.incidentArray])

    function prepareSalesForceRemediation(resp) {
        let tableData = [], tableObj = {};
        let buckets = Array.isArray(resp.remediation_info) ? resp.remediation_info : [];
        for (let i = 0; i < buckets.length; i++) {
            tableObj = {
                id: i + 1,
                attempts: buckets[i].attempts,
                completed: buckets[i].completed,
                action: buckets[i].action,
                info: <ReadMoreAndLess charLimit={80} readMoreText={ReadMore} readLessText={ReadLess}>{buckets[i].info}</ReadMoreAndLess>
            };
            tableData.push(tableObj);
        }
        setSalesForceRows(tableData);
        console.log(tableData, "tableData")
        return tableData;
    }

    return (
        <div>
            <div className="remediation-content">
                <ReactCardFlip isFlipped={isRemediationRootCauseFlipped} flipDirection="horizontal">
                    <Tile className="action first-tile"> {props.incidentArray.actionable !== "R" ?
                        <div>
                            <div>{props.incidentArray.actionable === "A" ?
                                <label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AcceptedSuggestionFor} {IncidentDetailsConstants.RemediationType}</label>
                                : <label className="carbon-display-Regular-14">{IncidentDetailsConstants.RemediationType}</label>}</div>

                            <div className="carbon-display-Regular-18">{props.actionable}</div>
                            <div className={"carbon-display-Regular-14 " + (props.actionTypeConfidence > 50 ? 'text-green' : 'text-danger')}>
                                <span>{props.actionTypeConfidence}</span>
                                <span>%</span>
                                <span className="name">{IncidentDetailsConstants.Confidence}</span>
                            </div> </div> : ''}

                        {!props.disableIncidentUpdate ?
                            <div className="rca-button-container">
                                {props.incidentArray.actionable !== "R" && props.incidentArray.actionable !== "A" ?
                                    <Button
                                        renderIcon={ThumbsUp32}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='secondary'
                                        onClick={handleRemediationRootCauseApprove}
                                    >{IncidentDetailsConstants.AcceptSuggestion}
                                    </Button>
                                    : ''}
                                {props.incidentArray.actionable === "R" ?
                                    <div style={{ position: 'static!important', top: '10px!important' }}>
                                        <label className="carbon-display-Regular-14">{IncidentDetailsConstants.RemediationType}</label>
                                        <br />
                                        <div className="feedback-tile">
                                            <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Feedback} </label>
                                            <br />
                                            <div>{props.incidentArray.actionable_feedback}</div>
                                        </div>
                                    </div> :
                                    <Button
                                        renderIcon={ThumbsDown32}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='tertiary'
                                        onClick={handleRemediationRootCauseReject}
                                    >{IncidentDetailsConstants.RejectSuggestion}
                                    </Button>
                                }
                            </div> : ''}
                    </Tile>

                    {isRemediationRootCauseApproveFlipped === true ?
                        <Tile className="action second-tile">
                            <div>
                                <div>{IncidentDetailsConstants.ToSubmitSuggestion},</div>
                                <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                            </div>
                            <div className="rca-button-container">
                                <Button
                                    renderIcon={Close16}
                                    tooltipAlignment="center"
                                    tooltipPosition="top"
                                    kind='tertiary'
                                    onClick={handleRemediationRootCauseFlip}
                                >{IncidentDetailsConstants.Back}
                                </Button>
                            </div>
                        </Tile>
                        :
                        RemediationRootCauseFeedbackClicked === false ?
                            <Tile className="action second-tile">
                                {!props.disableIncidentUpdate ?
                                    <div>
                                        <div className="feedback">{IncidentDetailsConstants.Feedback}</div>
                                        <div className="character-count">{RemediationRootCauseFeedbackCount}/50</div>

                                        <TextArea id="feedback" placeholder={IncidentDetailsConstants.TypeRejectionFeedback} maxLength="50" rows={2}
                                            onChange={(e) => { setRemediationRootCauseFeedbackCount(e.target.value.length); setRemediationRootCauseFeedback(e.target.value) }} />

                                        <div className="rca-button-container">
                                            <Button
                                                renderIcon={ArrowRight32}
                                                tooltipAlignment="center"
                                                tooltipPosition="top"
                                                kind='tertiary'
                                                disabled={!remediationRootCauseFeedback}
                                                onClick={handleRemediationRootCauseFeedback}
                                            >{IncidentDetailsConstants.Done}
                                            </Button>
                                            <Button
                                                renderIcon={Close16}
                                                tooltipAlignment="center"
                                                tooltipPosition="top"
                                                kind='tertiary'
                                                onClick={handleRemediationRootCauseFlip}
                                            >{IncidentDetailsConstants.Cancel}
                                            </Button>
                                        </div>
                                    </div> : ''
                                }
                            </Tile>
                            : <Tile className="action second-tile">
                                <div>
                                    <div>{IncidentDetailsConstants.ToSubmitFeedback},</div>
                                    <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                    <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                                </div>
                                <div className="rca-button-container">
                                    <Button
                                        renderIcon={Close16}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='tertiary'
                                        onClick={handleRemediationRootCauseFlip}
                                    >{IncidentDetailsConstants.Back}
                                    </Button>
                                </div>
                            </Tile>
                    }
                </ReactCardFlip>

                <ReactCardFlip isFlipped={isActionFlipped} flipDirection="horizontal">
                    <Tile className="action first-tile">
                        {props.incidentArray.action !== "R" ?
                            <div>
                                <div>{props.incidentArray.action === "A" ?
                                    <label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AcceptedSuggestionFor} {IncidentDetailsConstants.Action}</label>
                                    : <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Action}</label>}</div>

                                <div className="carbon-display-Regular-18">{props.somClassificationData.actions}</div>
                                <div className={"carbon-display-Regular-14 " + (props.actionConfidence > 50 ? 'text-green' : 'text-danger')}>
                                    <span>{props.actionConfidence}</span>
                                    <span>%</span>
                                    <span className="name">{IncidentDetailsConstants.Confidence}</span>
                                </div> </div> : ''}

                        {!props.disableIncidentUpdate ?
                            <div className="rca-button-container">
                                {props.incidentArray.action !== "R" && props.incidentArray.action !== "A" ?
                                    <Button
                                        renderIcon={ThumbsUp32}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='secondary'
                                        onClick={handleActionApprove}
                                    >{IncidentDetailsConstants.AcceptSuggestion}
                                    </Button>
                                    : ''}
                                {props.incidentArray.action === "R" ?
                                    <div>
                                        <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Action}</label>
                                        <br />
                                        <div className="feedback-tile">
                                            <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Feedback}</label>
                                            <br />
                                            <div>{props.incidentArray.action_feedback}</div>
                                        </div>
                                    </div> :
                                    <Button
                                        renderIcon={ThumbsDown32}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='tertiary'
                                        onClick={handleActionReject}
                                    >{IncidentDetailsConstants.RejectSuggestion}
                                    </Button>}
                            </div> : ''}
                    </Tile>

                    {isActionApproveFlipped === true ?
                        <Tile className="action second-tile">
                            <div>
                                <div>{IncidentDetailsConstants.ToSubmitSuggestion},</div>
                                <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                            </div>
                            <div className="rca-button-container">
                                <Button
                                    renderIcon={Close16}
                                    tooltipAlignment="center"
                                    tooltipPosition="top"
                                    kind='tertiary'
                                    onClick={handleActionFlip}
                                >{IncidentDetailsConstants.Back}
                                </Button>
                            </div>
                        </Tile>
                        :
                        ActionFeedbackClicked === false ?
                            <Tile className="action second-tile">
                                {!props.disableIncidentUpdate ?
                                    <div>
                                        <div className="feedback">{IncidentDetailsConstants.Feedback}</div>
                                        <div className="character-count">{ActionFeedbackCount}/50</div>

                                        <TextArea id="feedback" placeholder={IncidentDetailsConstants.TypeRejectionFeedback} maxLength="50" rows={2}
                                            onChange={(e) => { setActionFeedbackCount(e.target.value.length); setActionFeedback(e.target.value); }} />
                                        <div className="tab rca-button-container">
                                            <Button
                                                renderIcon={ArrowRight32}
                                                tooltipAlignment="center"
                                                tooltipPosition="top"
                                                kind='tertiary'
                                                disabled={!actionFeedback}
                                                onClick={handleActionFeedback}
                                            >{IncidentDetailsConstants.Done}
                                            </Button>
                                            <Button
                                                renderIcon={Close16}
                                                tooltipAlignment="center"
                                                tooltipPosition="top"
                                                kind='tertiary'
                                                onClick={handleActionFlip}
                                            >{IncidentDetailsConstants.Cancel}
                                            </Button>
                                        </div>
                                    </div> : ''
                                }
                            </Tile> : <Tile className="action second-tile">
                                <div>
                                    <div>{IncidentDetailsConstants.ToSubmitFeedback},</div>
                                    <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                    <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                                </div>
                                <div className="rca-button-container">
                                    <Button
                                        renderIcon={Close16}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='tertiary'
                                        onClick={handleActionFlip}
                                    >{IncidentDetailsConstants.Back}
                                    </Button>
                                </div>
                            </Tile>
                    }
                </ReactCardFlip>
                <br />
            </div>
            <div className="remediation-content remediation-steps">
                <ReactCardFlip isFlipped={isRemediationStepsFlipped} flipDirection="horizontal" >
                    <Tile className="remediation first-tile">
                        {props.incidentArray.action_desc !== 'R' ?
                            <div>
                                <div>{props.incidentArray.action_desc === "A" ?
                                    <label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AcceptedSuggestionFor} {IncidentDetailsConstants.RemediationSteps}</label>
                                    : <label className="carbon-display-Regular-14" style={{ display: 'flex', alignItems: 'flex-start' }}>{IncidentDetailsConstants.RemediationSteps}</label>
                                }</div>
                                <div className="steps-container">
                                    {/* <Steppers /> */}
                                    {QnALoader === false ?
                                        QuestionAnswers && QuestionAnswers.length > 0 ?
                                            <div className="stepsContainer-data">
                                                {/* <div>{QuestionAnswers[0].question}</div> */}
                                                <div>{QuestionAnswers[0].answer.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, "\"")}</div>
                                            </div>
                                            : IncidentDetailsConstants.NoDataAvailable
                                        : <InlineLoading description={DashboardConstants.Loading} />}

                                </div>
                            </div> : ''}

                        {!props.disableIncidentUpdate ?
                            <div className="tab rca-button-container">
                                {props.incidentArray.action_desc !== "R" && props.incidentArray.action_desc !== "A" ?
                                    <Button
                                        renderIcon={ThumbsUp32}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='secondary'
                                        onClick={handleRemediationStepsApprove}
                                    >{IncidentDetailsConstants.AcceptSuggestion}
                                    </Button> : ''}
                                <br></br>
                                {props.incidentArray.action_desc === "R" ?
                                    <div className="remediationSteps-feedback" style={{ textAlign: 'left', float: 'left' }}>
                                        <div className="feedback-tile"> <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Feedback} </label>
                                            <div>{props.incidentArray.action_desc_feedback}</div>
                                            <br />
                                            <label className="carbon-display-Regular-14">{IncidentDetailsConstants.RemediationSteps}</label>
                                            <div className="steps-container">
                                                {/* <Steppers /> */}
                                                <div className="stepsContainer-data" dangerouslySetInnerHTML={{
                                                    __html: QuestionAnswers && QuestionAnswers.length > 0 ? QuestionAnswers[0].question
                                                        : IncidentDetailsConstants.NoDataAvailable
                                                }}></div>
                                            </div>
                                        </div>
                                    </div> :
                                    <Button
                                        renderIcon={ThumbsDown32}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='tertiary'
                                        onClick={handleRemediationStepsReject}
                                    >{IncidentDetailsConstants.RejectSuggestion}
                                    </Button>}
                            </div> : ''}
                    </Tile>
                    {isRemediationStepsApproveFlipped === true ?
                        <Tile className="remediation second-tile" style={{ height: "250px" }}>
                            <div className={"carbon-display-Regular-14 toast-message"} id="suggestion-approve">
                                <div>
                                    <div>{IncidentDetailsConstants.ToSubmitSuggestion},</div>
                                    <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                    <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                                </div>
                                <div className="rca-button-container" style={{ bottom: '10px' }}>
                                    <Button
                                        renderIcon={Close16}
                                        tooltipAlignment="center"
                                        tooltipPosition="top"
                                        kind='tertiary'
                                        onClick={handleRemediationStepsFlip}
                                    >{IncidentDetailsConstants.Back}
                                    </Button>
                                </div>
                            </div>
                        </Tile> :
                        RemediationStepsFeedbackClicked === false ?
                            <Tile className="remediation second-tile">
                                {!props.disableIncidentUpdate ?
                                    <div>
                                        <div className="feedback">{IncidentDetailsConstants.Feedback}</div>
                                        <div className="character-count">{RemediationStepsFeedbackCount}/750</div>

                                        <TextArea id="feedback" placeholder={IncidentDetailsConstants.TypeRejectionFeedback} maxLength="750" rows={5}
                                            onChange={(e) => { setRemediationStepsFeedbackCount(e.target.value.length); setRemediationStepsFeedback(e.target.value) }} />

                                        <div className="rca-button-container">
                                            <Button
                                                renderIcon={ArrowRight32}
                                                tooltipAlignment="center"
                                                tooltipPosition="top"
                                                kind='secondary'
                                                disabled={!remediationStepsFeedback}
                                                onClick={handleRemediationStepsSubmitFeedback}
                                            >{IncidentDetailsConstants.Done}
                                            </Button>
                                            <Button
                                                renderIcon={Close16}
                                                tooltipAlignment="center"
                                                tooltipPosition="top"
                                                kind='tertiary'
                                                onClick={handleRemediationStepsFlip}
                                            >{IncidentDetailsConstants.Cancel}
                                            </Button>
                                        </div>
                                    </div> : ''
                                }
                            </Tile> :
                            <Tile className="remediation second-tile">
                                <div>
                                    <div>{IncidentDetailsConstants.ToSubmitFeedback},</div>
                                    <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                    <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                                </div>
                                <div className="rca-button-container">
                                    <Button
                                        renderIcon={Close16}
                                        kind='tertiary'
                                        onClick={handleRemediationStepsFlip}
                                    >{IncidentDetailsConstants.Back}
                                    </Button>
                                </div>
                            </Tile>
                    }
                </ReactCardFlip>
            </div >

            {props.workspace === workspaces.salesforce_ops &&
                <div className="salesforce-remediation-container">
                    <div className="margin-bottom-10px margin-top-10px">{remediation}</div>
                    <div><DashboardTable rows={salesForceRows} headers={SalesForceTableHeaders} showPagination={true} isSortingAllowed={true} /></div>
                </div>}

        </div >
    );
}